<template>
  <div class="c-modal third-login" v-if="pageVisible">
    <div class="mask">
      <Rights
        v-if="rightType == 'generate' || rightType == 'video' || rightType == 'invite'"
        :rightType="rightType"
        :create_type="props.create_type"
        :source="props.source"
      />
      <div class="content">
        <div class="mobile-title">
          <div class="left">{{ $$t("login.sign_in_mureka") }}</div>
          <img @click="closePage" src="@/assets/img/mobile/icon-close.png" alt="" />
        </div>
        <div class="close-btn" @click="closePage">
          <img src="@/assets/img/ic_close.png" alt="" />
        </div>
        <div class="bg-img">
          <div class="login-module-main login-in-main">
            <div class="login-img-box">{{ $$t("login.sign_in_mureka") }}</div>
            <div class="login-in-main-content">
              <GoogleThirdLogin @continueWith="continueWith" />
              <!-- <div @click="goSignUp" class="sign-up-block">Sign up with email</div> -->
            </div>
            <div class="third-login-box">
              <img @click="facebookLogin" src="@/assets/img/login/ic-facebook.png" alt="" />
              <img @click="discordLogin" src="@/assets/img/login/ic-discord.png" alt="" />
              <img @click="signInAppleLogin" src="@/assets/img/login/ic-apple.png" alt="" />
            </div>
            <!-- <p v-if="isDev()" class="forget-password-footer tc">
              Already have an account?
              <span @click="goLogin" class="a-link btn pointer">{{ $$t("login.login") }}</span>
            </p> -->
            <div class="terms">
              {{ $$t("login.continuing") }} <a href="/static/terms-20250709.pdf" class="a-link btn pointer" target="_blank"> {{ $$t("login.terms_of_use") }}</a> {{ $$t("login.and") }}
              <a href="/static/privacy-20250709.pdf" class="a-link btn pointer" target="_blank"> {{ $$t("login.privacy_policy") }}</a>
              {{ $$t("login.policy_end") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, watch, getCurrentInstance } from "vue";
import message from "@/components/functionCallComponent/message/message.js";
import apiUser from "@/api/api/apiUser.js";
import useUserDataStore from "@/store/userDataStore";
import { funComponentList } from "@/components/functionComp/index";
import { getParameterByName, isDev } from "@/utils/tools.js";
import GoogleThirdLogin from "@/components/login/GoogleThirdLogin.vue";
import Rights from "./rights.vue";
import { firebaseUtils } from "@/utils/analytic/firebaseUtils.js";
import globalConfig from "@/config/config.js";

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const { $$t } = globalProperties?.$i18n
//自定义函数组件无法使用全局组件，需要单独引入
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  okText: {
    type: String,
    default: "确定",
  },
  handleOk: {
    type: Function, //成功回调
    default: null,
  },
  handleCancel: {
    type: Function, //失败回调
    default: null,
  },
  remove: {
    type: Function, //传入移除节点方法,这里是createApp中的方法
    default: null,
  },
  content: {
    type: String,
    default: "自定义全局函数组件......",
  },
  rightType: {
    type: String, // 'generate' | 'login' | undefined, // 显示权益的类型
    default: "login",
  },
  create_type: {
    type: String,
    default: "2",
  },
  source: {
    type: String,
    default: "other",
  },
  signup_source: {
    type: String,
    default: "",
  },
});

const pageVisible = ref(false);
pageVisible.value = props.visible;
// 监听显示的消失，需要移除dom
watch(
  () => pageVisible.value,
  (val) => {
    !val && props.remove();
  }
);

const userDataStore = useUserDataStore();

const closePage = () => {
  pageVisible.value = false;
  localStorage.removeItem(`${globalConfig.appname}_create_data`);
  firebaseUtils.logClickEvent(props.rightType === "generate" ? "close_new_user_login" : "close_login", {
    create_type: props.create_type,
    page_route: window.location.pathname,
    source: props.source,
  });
};

const goLogin = () => {
  pageVisible.value = false;
  funComponentList.LogIn({
    // content: "在request.ts触发的函数式组件",
    handleOk: props.handleOk,
    handleCancel: props.handleCancel,
    rightType: props.rightType,
    create_type: props.create_type,
    source: props.source,
  });
};

const facebookLogin = () => {
  FB.login(function (respond) {
    console.log(respond);
    if(respond?.authResponse){
      userDataStore.threeLogin(respond?.authResponse?.accessToken, false, props.signup_source, "facebook_web").then(() => {
        facebookLoginOut()
        typeof props.handleOk === "function" && props.handleOk(true);
        pageVisible.value = false;
      });
    }
  }, { scope: "public_profile,email" });
};

const facebookLoginOut = () => {
  FB.getLoginStatus(function(response) {
    if (response.status === 'connected') {
      FB.logout(function(response) {
        console.log('Facebook 退出成功', response);
      });
    } else {
      console.log('用户未登录 Facebook');
    }
  });
};

const goSignUp = () => {
  message.error({
    maskClosable: true,
    position: "top",
    content: "Email registration not supported temporarily,Please continue with Google.",
  });
  // pageVisible.value = false
  // funComponentList.SignUp({
  //   // content: "在request.ts触发的函数式组件",
  //   handleOk: props.handleOk,
  //   handleCancel: props.handleCancel,
  //   rightType: props.rightType,
  // })
};

const discordLogin = () => {
  if (props.signup_source) {
    sessionStorage.setItem("signup_source", props.signup_source);
  }
  const clientId = "1271026704529362995"; // 从 Discord 应用获取
  const url = `${window.location.origin}${userDataStore.appLanguage !== "en" ? `/${userDataStore.appLanguage}/` : "/"}`
  
  const redirectUri = encodeURIComponent(url);
  const discordAuthUrl = `https://discord.com/oauth2/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=token&scope=identify`;

  // 重定向到 Discord 授权页面
  window.location.href = discordAuthUrl;
};

const continueWith = async (state) => {
  firebaseUtils.logClickEvent(props.rightType === "generate" ? "newuser_login" : "login", {
    create_type: props.create_type,
    source: props.source,
    page_route: window.location.pathname,
  });
  userDataStore.threeLogin(state.x_auth_token, false, props.signup_source).then(() => {
    typeof props.handleOk === "function" && props.handleOk(true);
    pageVisible.value = false;
  });
};

const initAppleLogin = () => {
  console.log("AppleID", AppleID.auth);
  if (AppleID?.auth) {
    const nonce = Math.random().toString(36).substr(2, 10);
    AppleID.auth.init({
      clientId: "ai.mureka.service",
      redirectURI: `${window.location.origin}/api/notify/ios${userDataStore.appLanguage!=='en'?`?lang=${userDataStore.appLanguage}`:""}`,
    });
  }
};

const signInAppleLogin = () => {
  try {
    if (props.signup_source) {
      sessionStorage.setItem("signup_source", props.signup_source);
    }
    AppleID.auth.signIn();
  } catch (error) {
    console.error(" Apple Sign In Error: ", error);
  }
};

onMounted(() => {
  console.log("orios.", props.create_type);
  if (props.rightType === "login") {
    firebaseUtils.logViewEvent("login", {
      create_type: props.create_type,
      page_route: window.location.pathname,
      source: props.source,
    });
  }

  initAppleLogin();
});
</script>

<style lang="scss" scoped>
.c-modal {
  color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  .mask {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 48px;
    .content {
      position: relative;
      left: 0;
      top: 0;
      transform: none;
      background: linear-gradient(130deg, #1a3c8d 0%, #695bc5 47%, #3a1b6f 100%);
      overflow: hidden;
      border-radius: 20px;
      .third-login-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 40px;
        height: 80px;
        margin-bottom: 8px;
        img {
          width: 48px;
          height: 48px;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .login-in-main {
        width: 100%;
      }
      .forget-password-footer {
        font-size: 14px;
        font-weight: normal;
        line-height: 22px;
        letter-spacing: 0em;
        color: #ffffff;
        margin-bottom: 40px;
        span {
          color: #94adff;
        }
        @media screen and (max-width: 768px) {
          margin-bottom: 20px;
        }
      }
    }
  }
  &.third-login {
    .content {
      min-width: 400px;
    }
  }
  @media screen and (max-width: 768px) {
    .mask {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 24px;
      .close-btn {
        display: none;
      }
      .content {
        box-sizing: content-box;
        margin: 0;
        padding: 20px;
        width: 300px;
        min-width: unset;
        .terms {
          margin-bottom: 0;
        }
      }
    }
  }
}

.sign-up-block {
  padding: 14px 16px;
  text-align: center;
  height: 52px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  margin-bottom: 8px;
  cursor: pointer;

  font-size: 16px;
  font-weight: normal;
  line-height: 24px;

  &:hover {
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
}
</style>
